export default __webpack_public_path__ + "static/media/misc-books4-1440w.888cfe2a.png";